// Home
import Home from './../views/Home'

// Form
import FormHome from './../views/form/Home'

// User
import UserLogin from './../views/user/Login'
import UserRegister from './../views/user/Register'
import UserUpdate from './../views/user/Update'
import UserLogout from './../views/user/Logout'
import UserPasswordForgot from './../views/user/ForgotPassword'
import UserPasswordToken from './../views/user/UserPasswordToken'
import ActorsLogin from './../views/user/ActorsLogin'

// User / Produit
import UserProductList from './../views/user/product/List'

// Take picture
import TakePicture from './../views/form/TakePicture'
import TakePictureSuccess from './../views/form/TakePictureSuccess'

// Welcome
import Welcome from './../views/Welcome'

// Blocked
import Blocked from './../views/Blocked'

// Complements
import Complements from './../views/complements/Complements'

// 404
import PageNotFound from './../views/404NotFound'

// Middleware
import {middlewareUserAuth, middlewareUserNotConnect, middlewareUserHome} from './Middlewares.js'

var routes = {
    list: [
        { path: '/', component: Home, name: 'home', beforeEnter: middlewareUserHome},

        // Form
        { path: '/form', component: FormHome, name: 'form.home'},

        // User
        { path: '/utilisateur/acteurs', component: ActorsLogin, name: 'user.login.actors'},
        { path: '/utilisateur/connexion', component: UserLogin, name: 'user.login'},
        { path: '/utilisateur/mot-de-passe-oublie', component: UserPasswordForgot, name: 'user.password-forgot'},
        { path: '/utilisateur/reset-token', component: UserPasswordToken, name: 'user.password-token'},
        { path: '/utilisateur/inscription', component: UserRegister, name: 'user.register'},
        { path: '/utilisateur/modifier', component: UserUpdate, name: 'user.update', beforeEnter: middlewareUserAuth},
        { path: '/utilisateur/deconnexion', component: UserLogout, name: 'user.logout'},
        // User / Produit
        { path: '/utilisateur/produit/liste', component: UserProductList, name: 'user.product.list', beforeEnter: middlewareUserAuth},

        // Welcome
        { path: '/bienvenue', component: Welcome, name: 'welcome', beforeEnter: middlewareUserNotConnect},

        // Complements
        { path: '/complements', component: Complements, name: 'complement'},

        // Take picture
        { path: '/p/success', component: TakePictureSuccess, name: 'take-picture-success'},
        { path: '/p/:id', component: TakePicture, name: 'take-picture'},

        // 
        { path: '/blocked', component: Blocked, name: 'blocked'},

        // 404 not found
        { path: "*", component: PageNotFound, name: '404' }
    ],
    ban: []
}

export default routes



// WEBPACK FOOTER //
// ./src/companies/default/router/routes.js